import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, Input, SimpleChange } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';

import { Chart, registerables } from 'chart.js';

import { DatePipe } from '@angular/common';
import { DataGrafica } from 'src/app/models/data-grafica';
import { DataToGraf } from 'src/app/models/data-graf';
import * as moment from 'moment';

const datePipe = new DatePipe('en-US');


// const baseConfig: Chart.ChartConfiguration = {
//   type: 'line',
//   data: {
//     labels: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00",
//          "06:00", "07:00", "08:00", "09:00", "10:00", "11:00",
//          "12:00", "13:00", "14:00", "15:00", "16:00", "17:00",
//          "18:00", "19:00", "20:00", "21:00", "22:00", "23:00" ],
//     datasets: [{
//       label: "",
//       backgroundColor: "#3e95cd",
//       borderColor: "",
//       data: [75, 70, 85, 80, 79, 85, 79, 65 , 68, 62], //EJE Y
//     }]
//   },
//   options: {
//     legend: { 
//       display: true 
//     },
//     scales: {
//       xAxes: [{ 
//         scaleLabel: {
//           labelString: 'tiempo',
//           display: true,
//         }
//       }],
//       yAxes: [{ 
//         scaleLabel: {
//           labelString: 'oC',
//           display: true,
//         }
//       }],
//     },
//     title: {
//       display: true,
//       text: ""
//     },
//     maintainAspectRatio: true,
//     responsive: true,
//   }
// }

const data = {
  labels: ['Apples', 'Oranges', 'Mixed Fruit'],
  datasets: [
    {
      label: 'Apples',
      data: [0, 50, 45, 100],
      backgroundColor: 'rgba(40,125,200,.5)',
      borderColor: 'rgb(40,100,200)',
      fill: true,
      lineTension: 0,
      radius: 5,
    },
    {
      label: 'Oranges',
      data: [30, 90, 111, 20],
      backgroundColor: 'rgba(75,10,125,.5)',
      borderColor: 'rgb(75,10,125)',
      fill: true,
      lineTension: 0.2,
      radius: 5,
    },
  ],
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  title: {
    display: true,
    position: 'top',
    text: 'Apples to Oranges',
    fontSize: 12,
    fontColor: '#666',
  },
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      fontColor: '#999',
      fontSize: 14,
    },
    scales: {
      x:[{ 
          scaleLabel: {
            labelString: 'tiempo',      
            display: true,
          } 
        }],
      y:[{ 
        scaleLabel: {
          labelString: '°C',
          display: true,
        }
      }],
    }
  },
};

const temp: string = "TEMPERATURA";
const hume: string = "HUMEDAD";
const lumi: string = "LUMINOSIDAD";

@Component({
  selector: 'app-grafica-bar-new',
  templateUrl: './grafica-bar-new.component.html',
  styleUrls: ['./grafica-bar-new.component.scss']
})
export class GraficaBarNewComponent implements  OnInit {
  
    DEBUG: boolean = false;
  
    constructor(private elementRef: ElementRef, private _cdref:ChangeDetectorRef) {
      Chart.register(...registerables);
    }
  
    //cargamos la opcion seleccionada por el radiobutton
  
    @Input() dataGrafica: DataGrafica;
    dataToGraf: DataToGraf;
  
  // Input para la fecha EJEX
  
    name = 'ChartJs';
    chart: any;
    ctx: any = document.getElementById('myChart') as HTMLElement;
    flagChart: boolean = false;
  
    @ViewChild('myChart', { static: false }) private chartRef: ElementRef;
  
  
    timeIni: number;
    timeFin: number;
    tipoGrafica: string;
    data: number[] = [];
    labels: any[] = [];
  
    flagViewGraf: boolean = false;
  
    ngOnInit(){
      this.ctx = document.getElementById('myChart') as HTMLElement;
      // console.log('[Grafica LINE] ngOnInit');
      
      // this._cdref.detectChanges();
  
      // this.createChart();
    }
  
  
    ngAfterViewInit() {
      this.ctx = document.getElementById('myChart') as HTMLElement;
      // console.log('[Grafica LINE] ngAfterViewInit');
      
      // this._cdref.detectChanges();
  
      // this.createChart();
  
      
    }
  
    ngOnChanges(changes: SimpleChange): void {
      this.ctx = document.getElementById('myChart') as HTMLElement;
      
      if(this.dataGrafica != undefined){
            //Obtenemos los datos pasados a la gráfica
        if(this.DEBUG){
          console.log('[Grafica LINE]  value changed' + this.tipoGrafica);
          console.log(this.dataGrafica);
        }
  
        this.timeIni = this.dataGrafica.timeIni; 
        this.timeFin = this.dataGrafica.timeFin;
        this.tipoGrafica = this.dataGrafica.tipoGrafica;
        
    
        // Modificamos las opciones de los ejes de la grafica dependiendo de los datos recibidos
        this.confDataGrafica();
      }
  
      // if (this.chart){
      //   console.log("La grafica existe y la limpiamos");
      //   this.chart.clear();
      //   this.chart.destroy();
      // }
      // this.configGrafica();
  
      
    }
  
    confDataGrafica(){
      //Limpiamos los valores
      this.data = [];
      this.labels = [];
  
      let horaIni;
      let horaFin;
      let tiempo;
      horaIni = datePipe.transform(this.dataGrafica.data.timestamp[0], 'HH:mm dd/MM/YYY');
      horaFin = datePipe.transform(this.dataGrafica.data.timestamp[this.dataGrafica.data.timestamp.length-1], 'HH:mm dd/MM/YYY');
  
      if(this.DEBUG){
        console.log(horaIni);
        console.log(horaFin);
      }
  
      this.data = this.dataGrafica.data.data;
      this.asyncMethodConvertTime(); 
  
    }
  
    async asyncMethodConvertTime() {
      if(this.DEBUG){
        console.log(this.labels);
      }
  
      let tiempo;
      for (let i = 0; i < this.dataGrafica.data.timestamp.length; i++) {
        if(this.dataGrafica.data.timestamp[i] != undefined){
          //console.log(moment(this.dataGrafica.data.timestamp[i]).format("HH:mm"));
          tiempo = moment(this.dataGrafica.data.timestamp[i]).format("HH:00");
          if (tiempo == "00:00"){
            this.labels.push(moment(this.dataGrafica.data.timestamp[i]).format("DD/MM/YYYY"));
          }else{
            this.labels.push(moment(this.dataGrafica.data.timestamp[i]).format("HH:00"));
          }
          
        }
      }
      if(this.DEBUG){
        console.log("asyncMethodConvertTime");
        console.log(this.labels);
      }
  
      if (this.chart){
        if(this.DEBUG){
          console.log("La grafica existe y la limpiamos");
        }
        
        this.chart.clear();
        this.chart.destroy();
      }
      this.configGrafica();
    }
  
    public configGrafica(){
      //cargamos la opcion seleccionada por el radiobutton
      // Seleccionamos la gráfica que queremos con las opciones personalizadas de cada una
      switch(this.tipoGrafica) { 
        case temp: { 
           //TEMPERATURA
           options.legend.scales.y[0].scaleLabel.labelString = "°C";  
           data.datasets[0].data = this.data; //Datos eje Y
           data.labels = this.labels; //Datos eje X
           data.datasets[0].backgroundColor = '#FF98002A';
           data.datasets[0].borderColor = '#FF9800';
           options.title.text = this.tipoGrafica;
           this.flagViewGraf = true;
           break; 
        } 
        case hume: { 
           //HUMEDAD
           options.legend.scales.y[0].scaleLabel.labelString = "%"; 
           data.datasets[0].data = this.data;//Datos eje Y
           data.labels = this.labels; //Datos eje X
           data.datasets[0].backgroundColor = '#1E88E52A';
           data.datasets[0].borderColor = '#1E88E5';
           options.title.text = this.tipoGrafica;
           this.flagViewGraf = true;
           break; 
        } 
        case lumi: { 
          //LUMINOSIDAD; 
          options.legend.scales.y[0].scaleLabel.labelString = "lum";
          data.datasets[0].data = this.data;//Datos eje Y
          data.labels = this.labels; //Datos eje X
          data.datasets[0].backgroundColor = '#FDD8352A';
          data.datasets[0].borderColor = '#FDD835';
          options.title.text = this.tipoGrafica;
          this.flagViewGraf = true;
          break; 
        } 
        default: { 
           //statements; 
           break; 
        } 
     }
  
     this.createChart();
        
    }
  
    createChart(){
      // this.flagViewGraf = true;
      this.chart = new Chart(this.ctx, {
        type: 'line',
        data: data,
        options: options,
      });
    }
  
  }
  